// Source: https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
var getCircularReplacer = function () {
    var seen = new WeakSet();
    return function (_key, value) {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
/**
 * Supports an object with circular references
 * @param obj
 * @returns
 */
export function stringifySave(obj) {
    return JSON.stringify(obj, getCircularReplacer());
}
//# sourceMappingURL=JsonHelpers.js.map